import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollProgressBar() {
  const [scrollPercent, setScrollPercent] = useState(0);
  const location = useLocation();

  const updateScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = (scrollTop / windowHeight) * 100;
    setScrollPercent(isNaN(scrolled) ? 0 : scrolled);
  };

  useEffect(() => {
    window.addEventListener("scroll", updateScroll, { passive: true });
    return () => window.removeEventListener("scroll", updateScroll);
  }, []);

  useEffect(() => {
    // Reset scroll progress on route change
    setScrollPercent(0);
  }, [location.pathname]);

  return (
    <div className="fixed top-0 left-0 w-full h-0.5 z-[9999] bg-transparent">
      <div
        className="h-full bg-[#44b388] transition-all duration-75"
        style={{ width: `${scrollPercent}%` }}
      />
    </div>
  );
}
